import GoogleSearch1818 from '@svg/poi-modal/google_search_18_18.svg';
import NaverSearch88 from '@svg/poi-modal/naver_search_8_8.svg';
import LinkForZzimcarAndroid from '../common/link-for-zzimcar-android';

const STYLE_AND_TEXT = {
  google: {
    backgroundColor: '#FFF',
    padding: `${1 / 16}rem`,
    text: '구글에서 검색',
  },
  naver: {
    backgroundColor: '#02C75A',
    padding: `${6 / 16}rem`,
    text: '네이버에서 검색',
  },
};

const OuterSearchLink = ({ type, link }: { type: 'google' | 'naver'; link: string }) => {
  const { backgroundColor, padding, text } = STYLE_AND_TEXT[type];
  return (
    <LinkForZzimcarAndroid
      className='flex flex-row items-center gap-1 bg-white border border-gray-200 px-8pxr py-6pxr rounded-17pxr'
      href={link}
      target='_blank'
      rel='noreferrer'
    >
      <span className='rounded-18pxr w-20pxr h-20pxr' style={{ padding, backgroundColor }}>
        {type === 'google' ? <GoogleSearch1818 /> : <NaverSearch88 />}
      </span>
      <p className='text-gray-800 body-14-r line-clamp-1'>{text}</p>
    </LinkForZzimcarAndroid>
  );
};

export default OuterSearchLink;
